import { DataTableColumn, DataTableColumnType } from '../_custom/DataTable/DataTable.types';
import { DATA_PENDING_COLUMN_FIELD, EXCLUDED_COLUMN_TYPES, EXCLUDED_COMPONENT_FIELDS, VALUE_BEARING_MODAL_FIELDS } from './constants';

type BuildPropertyColumnsOptions = {
    valueBearingModalFields?: Set<string>;
    // Mirrors DataTable's table-mode gate on the Data Pending column.
    dataPendingEnabled?: boolean;
};

// Drops the columns the drawer never shows: pure-UI types, the row kebab, and icon-only modal actions.
export function buildPropertyColumns(
    columns: DataTableColumn[] | undefined | null,
    options: BuildPropertyColumnsOptions = {},
): DataTableColumn[] {
    const valueBearingModalFields = options.valueBearingModalFields ?? VALUE_BEARING_MODAL_FIELDS;
    const dataPendingEnabled = options.dataPendingEnabled ?? true;

    return (columns ?? []).filter((column) => {
        if (EXCLUDED_COLUMN_TYPES.includes(column.type)) return false;
        if (column.type === DataTableColumnType.COMPONENT && EXCLUDED_COMPONENT_FIELDS.includes(column.field)) return false;
        if (column.field === DATA_PENDING_COLUMN_FIELD && !dataPendingEnabled) return false;
        if (column.type === DataTableColumnType.MODAL_ACTION && !valueBearingModalFields.has(column.field)) return false;
        return true;
    });
}
